<div class="sec-title">
    <h1>Modifier la maquette</h1>
</div>
<div><a class="btn btn-action" href="/maquettes" routerLink="/maquettes" role="button"><i class="bi bi-arrow-90deg-left"></i> retour aux maquettes</a></div>
<form class="col-lg-10 col-md-12" [formGroup]="editTemplateForm" (ngSubmit)="onSubmit(editTemplateForm.value)" novalidate>
    <fieldset>
        <legend>Les détails</legend>
        <div class="fieldset-wrap">
            <div class="form-group mb-3">
                <label for="template_name" class="form-label">Nom</label>
                <input type="text" class="form-control" name="template_name" id="template_name" formControlName="template_name" value="{{templateInfo.template_name}}" />
            </div>
    
            <div class="form-group mb-3">
                <label for="template_content" class="form-label">Contenu</label>
                <ckeditor [config]="ckEditorWithImageConfig" (init)="readyCKEditor($event)" name="template_content" id="template_content" formControlName="template_content" data="{{templateInfo.template}}"></ckeditor>
            </div>
        </div>
    </fieldset>

    <button type="submit" class="btn btn-primary">Enregistrer.</button>
  
  </form>